import Authenticated from "@/Layouts/Authenticated";
import { BriefcaseIcon } from "@heroicons/react/solid";
import PageHeading from "@/Components/PageHeading";
import { useForm } from "@inertiajs/inertia-react";
import React from "react";

const Index = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Settings", route: null },
        { name: "Change Password", route: null },
    ];

    const meta = [{ name: "Location", icon: BriefcaseIcon }];

    const { data, setData, errors, post, processing, clearErrors, reset } =
        useForm({
            current_password: "",
            password: "",
            password_confirmation: "",
        });

    function handleSubmit(e) {
        e.preventDefault();
        clearErrors();
        post(route("settings.password"), {
            onSuccess: () => reset(),
        });
    }

    return (
        <div className="py-6">
            <PageHeading heading="Change Password" breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 pb-12 pt-10 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <label
                                    htmlFor="current_password"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Current Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="current_password"
                                        name="current_password"
                                        type="password"
                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                        onChange={(e) =>
                                            setData(
                                                "current_password",
                                                e.target.value
                                            )
                                        }
                                        value={data.current_password}
                                    />
                                </div>
                                {errors.current_password && (
                                    <p className="mt-2 text-sm text-red-600">
                                        {errors.current_password}
                                    </p>
                                )}
                            </div>
                            <div>
                                <label
                                    className="block text-sm font-medium text-gray-700"
                                    htmlFor="password"
                                >
                                    Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="password"
                                        name="password"
                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                        type="password"
                                        onChange={(e) =>
                                            setData("password", e.target.value)
                                        }
                                        value={data.password}
                                    />
                                </div>
                                {errors.password && (
                                    <p className="mt-2 text-sm text-red-600">
                                        {errors.password}
                                    </p>
                                )}
                            </div>
                            <div>
                                <label
                                    className="block text-sm font-medium text-gray-700"
                                    htmlFor="password_confirmation"
                                >
                                    Repeat Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="password_confirmation"
                                        name="password_confirmation"
                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                        type="password"
                                        onChange={(e) =>
                                            setData(
                                                "password_confirmation",
                                                e.target.value
                                            )
                                        }
                                        value={data.password_confirmation}
                                    />
                                </div>
                                {errors.password_confirmation && (
                                    <p className="mt-2 text-sm text-red-600">
                                        {errors.password_confirmation}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    className="btn-base btn-primary"
                                    disabled={processing}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {/*<div className="mx-auto px-4 sm:px-6 lg:px-8">*/}
                {/*    <h2 className="text-lg font-medium leading-6 text-gray-900">*/}
                {/*        Overview*/}
                {/*    </h2>*/}
                {/*    <dl className="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">*/}
                {/*        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">*/}
                {/*            <dt className="truncate text-sm font-medium text-gray-500">*/}
                {/*                Title*/}
                {/*            </dt>*/}
                {/*            <dd className="mt-1 text-3xl font-semibold text-gray-900">*/}
                {/*                Stats*/}
                {/*            </dd>*/}
                {/*        </div>*/}
                {/*    </dl>*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

Index.layout = (page) => <Authenticated children={page} />;

export default Index;
